import { usePortal } from '@fourthwall/utils/dist/hooks/usePortal';
import { useEffect, useState } from 'react';
export const useDrawer = (id, options) => {
    const drawerRoot = usePortal(id);
    const [drawerActive, setDrawerActive] = useState(false);
    const drawerOpen = () => {
        setDrawerActive(true);
    };
    const drawerClose = () => {
        setDrawerActive(false);
    };
    useEffect(() => {
        if (options?.disableBodyScroll) {
            document.body.style.overflow = drawerActive ? 'hidden' : '';
        }
    }, [drawerActive, options?.disableBodyScroll]);
    return {
        drawerRoot,
        drawerActive,
        drawerOpen,
        drawerClose,
    };
};
